export const SELECT_MONEV = "@monev/SELECT_USER";
export const SELECT_DOKUMEN_KERJASAMA = "@monev/SELECT_DOKUMEN_KERJASAMA";

export const INITIALIZE_CREATE_MONEV = "@monev/INITIALIZE_CREATE_MONEV";

export const UPDATE_NAMA_KEGIATAN = "@monev/UPDATE_NAME";
export const UPDATE_LOKASI = "@monev/UPDATE_LOKASI";
export const UPDATE_TANGGAL_MULAI = "@monev/UPDATE_TANGGAL_MULAI";
export const UPDATE_TANGGAL_SELESAI = "@monev/UPDATE_TANGGAL_SELESAI";
export const UPDATE_DESKRIPSI = "@monev/UPDATE_DESKRIPSI";
export const UPDATE_EVALUASI = "@monev/UPDATE_EVALUASI";
export const UPDATE_TAUTAN = "@monev/UPDATE_TAUTAN";
export const UPDATE_DOK_ID = "@monev/UPDATE_DOK_ID";

export const DELETE_FILE = "@monev/DELETE_FILE";

export const UPDATE_FILE = "@dokumenKerjasama/UPDATE_FILE";
export const UPDATE_FILE_INPUT_PESERTA = "@monev/UPDATE_FILE_PATH_PESERTA";

export const UPDATE_PENYELENGGARA = "@monev/UPDATE_PENYELENGGARA";
export const UPDATE_PESERTA = "@monev/UPDATE_PESERTA";
export const UPDATE_DESKRIPSI_PESERTA = "@monev/UPDATE_DESKRIPSI_PESERTA";

export const GET_MONEV_REQUEST = "@monev/GET_MONEV_REQUEST";
export const GET_MONEV_SUCCESS = "@monev/GET_MONEV_SUCCESS";
export const GET_MONEV_FAILURE = "@monev/GET_MONEV_FAILURE";

export const GET_DETAIL_REQUEST = "@monev/GET_DETAIL_REQUEST";
export const GET_DETAIL_SUCCESS = "@monev/GET_DETAIL_SUCCESS";
export const GET_DETAIL_FAILURE = "@monev/GET_DETAIL_FAILURE";

export const GET_DOKUMEN_REQUEST = "@monev/GET_DOKUMEN_REQUEST";
export const GET_DOKUMEN_SUCCESS = "@monev/GET_DOKUMEN_SUCCESS";
export const GET_DOKUMEN_FAILURE = "@monev/GET_DOKUMEN_FAILURE";

export const UPDATE_MONEV_REQUEST = "@monev/UPDATE_MONEV_REQUEST";
export const UPDATE_MONEV_SUCCESS = "@monev/UPDATE_MONEV_SUCCESS";
export const UPDATE_MONEV_FAILURE = "@monev/UPDATE_MONEV_FAILURE";

export const CREATE_MONEV_REQUEST = "@monev/CREATE_MONEV_REQUEST";
export const CREATE_MONEV_SUCCESS = "@monev/CREATE_MONEV_SUCCESS";
export const CREATE_MONEV_FAILURE = "@monev/CREATE_MONEV_FAILURE";